module.exports = __webpack_public_path__ + "media/master.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/master.png
// module id = 44
// module chunks = 0